import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import TransportImg1 from '../../assest/Truck-1.png';
import TransportImg2 from '../../assest/Truck-2.png';
import TransportImg3 from '../../assest/Truck-3.png';

const materialList = [
  {
    name: "Truck Transport",
    image: TransportImg1,
    specs: "Heavy materials and equipment transport.",
    description: "Reliable trucks for transporting large construction materials across sites.",
  },
  {
    name: "Forklift Service",
    image: TransportImg2,
    specs: "On-site lifting and material movement.",
    description: "Ideal for moving pallets, heavy supplies, and machinery within site boundaries.",
  },
  {
    name: "Crane Operation",
    image: TransportImg3,
    specs: "Vertical material movement and lifting.",
    description: "Essential for lifting steel, concrete, and other large elements on construction sites.",
  },
];

const translations = {
  gb: {
    heading: "Material Transport Services",
    introText: "Efficient transport solutions for your construction materials and equipment.",
    categoriesTitle: "Available Transport Types",
    featuredTitle: "Top Transport Options",
    featuredDescription: "Reliable and efficient vehicles and tools for material handling.",
  },
  sa: {
    heading: "خدمات نقل المواد",
    introText: "حلول نقل فعالة لمواد ومعدات البناء الخاصة بك.",
    categoriesTitle: "أنواع النقل المتاحة",
    featuredTitle: "أفضل وسائل النقل",
    featuredDescription: "مركبات وأدوات موثوقة وفعالة للتعامل مع المواد.",
  },
};

const MaterialTransport = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={materialList}
      language={language}
    />
  );
};

export default MaterialTransport;
